import React from "react"
import clsx from "clsx"

import { Asset, Breadcrumb } from "components"

function Hero({ category, post }) {
  return (
    <header
      className={clsx(
        "pb-24 wrapper default-grid pt-10 md:pt-30",
        category.color === "Blue" && "bg-darkNavy",
        category.color === "Purple" && "bg-darkPurple",
        category.color === "Grey" && "bg-mineralGray"
      )}
    >
      <div className="space-y-6 col-span-full md:col-span-8">
        <Breadcrumb
          label={category.name}
          href={`/news/${category?.slug === "/" ? "" : category?.slug + "/"}`}
          appearance="secondary"
        />
        <h1 className="text-white h1">{post.title}</h1>
      </div>
      <div className="relative self-end -mb-32 pointer-events-none select-none col-span-full md:col-span-4">
        <div className="aspect-w-1 aspect-h-1 bg-darkOverlay">
          <Asset asset={post.image} style={{ position: "absolute" }} />
        </div>
        <div className="absolute w-32 sm:w-48 md:w-32 lg:w-48 top-4 -right-6 sm:-right-fluidMargin xl:-right-26">
          <div className="overflow-hidden transform translate-x-3 -skew-x-12">
            <div className="relative w-full transform skew-x-12 h1">
              &nbsp;
              <div
                className="absolute w-full right-3 bg-gold"
                style={{ top: "0.167em", height: "0.1333em" }}
              />
              <div
                className="absolute w-full right-3 bg-gold"
                style={{ bottom: "0.117em", height: "0.1333em" }}
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Hero
